import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import ChatFeedList from '../List'
import { MessageInput, LoadingIndicator } from '../../message'
import modules from './container.module.scss'
import { withTheme } from '../../../../common'
import { getAccessibleTextColor, styled } from '../../../../utilities'
import { BOTNAME_LABEL, OSU_CHAT_ARIA_REGION } from '../../../../utilities/constants'

const StyledComponent = styled.span`
  ${({ theme = {} }) => {
      const { background, color } = theme
      return {
        backgroundColor: background,
        color: color ? color : background ? getAccessibleTextColor(background) : ''
    }
  }}
`;

const PREFIX = `${BOTNAME_LABEL} says... | `

const Container = (props = {}) => {
    const { component, messages, handleInput, loading, setLoading, className, ResponseProps, inputProps = {} } = props
    const messagesRef = useRef({})
    const chatbotRef = useRef({})
    const defaultInputRef = useRef()
    const CustomComponent = component
    
    useEffect(() => {
        if(messages?.length === 1 && messages[0].welcome && messagesRef?.current instanceof Element) {
            messagesRef?.current.focus()
        }
    }, [messages?.length])
    
    const crossOriginTitleChange = (title = '') => {
        try {
            if(!title) {
                if(window.top.document.title.startsWith(PREFIX)) {
                    window.top.document.title = window.top.document.title.replace(PREFIX, '')
                }
            } else {
                const topTitle = window?.top?.document?.title
                if(!topTitle.startsWith(PREFIX)) {
                    window.top.document.title = PREFIX + topTitle
                }
            }
        } catch (error) {
            console.error('Error updating title', error)
        }
    }

    const clearTitle = () => {
        if(document.title.startsWith(PREFIX)) {
            document.title = document.title.replace(PREFIX, '')
        }
        crossOriginTitleChange()
    }

    const lastMessage = messages ? messages[messages.length - 1] : {}
    const newResponse = lastMessage?.type === 'response'

    useEffect(() => {
        if(messages.length > 0 && newResponse) {
            const docHasFocus = document.hasFocus()
            const chatHasFocus = chatbotRef?.current instanceof Element && chatbotRef.current.contains(document.activeElement)

            if (document.hidden || !docHasFocus || !chatHasFocus) {
                const title = document.title
                
                if(!title.startsWith(PREFIX)) {
                    document.title = PREFIX + title;
                }
            }
          }
    }, [messages?.length, newResponse])

    const triggerInputFocus = () => {
        const inputRef = (inputProps?.ref ?? defaultInputRef)?.current
        if(inputRef) {
            inputRef.focus()
        }

    }

    return <StyledComponent ref={chatbotRef} as={CustomComponent} className={`${modules.chatbotWindow} ${className}`.trim()}>
        <div tabIndex="0" id={OSU_CHAT_ARIA_REGION} aria-live="polite" ref={messagesRef} className={modules.wrapper}>
            <ChatFeedList triggerInputFocus={triggerInputFocus} ResponseProps={ResponseProps} handleInput={handleInput} messages={messages} />
        </div>
        {loading && <div className={modules.loading}>
            <LoadingIndicator />
        </div>}
        <MessageInput {...inputProps} ref={inputProps?.ref ?? defaultInputRef} onFocus={clearTitle} setLoading={setLoading} handleInput={handleInput} />
    </StyledComponent>
}


Container.defaultProps = {
    messages: [],
    loading: false,
    component: 'div',
    className: ''
}

Container.propTypes = {
    messages: PropTypes.array,
    handleInput: PropTypes.func,
    setLoading: PropTypes.func,
    loading: PropTypes.bool,
    component: PropTypes.string
}

export default withTheme(Container)